import { getLocalApi } from "./localApi";
import { CancellationFee } from "app/shared/model/CancellationFee";
import apiConfig from "app/api/apiConfig.json";

import { getDivisionId } from "app/shared/division/getDivisionId";

function mapDto(dto: any, divisionId: number): CancellationFee {
  return {
    id: dto.productId ?? dto.id ?? 0,
    name: dto.productName ?? dto.name ?? "",
    divisionId: dto.divisionId ?? divisionId,
    accountCategoryId: dto.accountCategoryId ?? 0,
    accountCategoryText: dto.accountCategoryText ?? "",
    productCategoryId: dto.productCategoryId ?? 0,
    productCategoryText: dto.productCategoryText ?? "",
    isPublished: dto.active ?? false,
    active: dto.active ?? false,
    schools: Array.isArray(dto.schools)
      ? dto.schools.map((school: any) => ({
          schoolId: school.schoolId ?? school.id ?? 0,
          schoolName: school.schoolName ?? school.name ?? '',
          centreId: school.centreId ?? 0,
          centreName: school.centreName ?? school.centreName ?? '',
        }))
      : [],
    schoolIds: Array.isArray(dto.schoolIds) ? dto.schoolIds : [],
    centreIds: Array.isArray(dto.centreIds) ? dto.centreIds : [],
    lastModifiedDate: dto.lastModifiedDate ?? null,
    lastUpdatedBy: dto.lastModifiedBy ?? "",
    entityUpdate: dto.entityUpdate,
  };
}

export async function getAllCancellationFees(divisionId?: number): Promise<CancellationFee[]> {
  const localApi = await getLocalApi();
  const id = divisionId ?? getDivisionId();
  const endpoint = apiConfig.cancellationfees_get_all.replace("{divisionId}", String(id));
  const result = await localApi.fetchList(
    endpoint,
    (dto: any) => mapDto(dto, id),
    "Unable to fetch cancellation fees",
    (res: any) => (Array.isArray(res) ? res : res?.data ?? [])
  );
  return result;
}